import { render, staticRenderFns } from "./ResourceDownloadAuth.vue?vue&type=template&id=66d7e72e&"
import script from "./ResourceDownloadAuth.vue?vue&type=script&lang=js&"
export * from "./ResourceDownloadAuth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports